import { NavLink } from "react-router-dom";
import { memo } from "react";
import { TabMenuProps } from "./types";
import { classNames, transformRoute, useTranslate } from "helpers";
import { Routes as FleetWarehouseRoutes } from "ui/modules/fleet/warehouses/navigation";
import { ReactSVG } from "react-svg";

const TabMenu: React.FC<TabMenuProps> = (props) => {
  const { warehouseId } = props;

  const { t } = useTranslate();

  return (
    <div className="flex border-b border-slate-200">
      <NavLink
        to={transformRoute(FleetWarehouseRoutes.FleetWarehouseDetailPageRouter, {
          id: warehouseId,
        })}
      >
        {({ isActive }) => (
          <div
            className={classNames(
              "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 ml-3 hover:text-sky-600",
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600"
            )}
          >
            <ReactSVG
              src="/media/icons/info.svg"
              className={classNames(
                "w-5 h-5 group-hover:stroke-sky-600",
                isActive ? "stroke-sky-600" : "stroke-slate-500"
              )}
            />
            {t("admin.fleet.warehouses.tab.details")}
          </div>
        )}
      </NavLink>

      <NavLink
        to={transformRoute(FleetWarehouseRoutes.FleetWarehouseTireSetSearchPageRouter, {
          id: warehouseId,
        })}
      >
        {({ isActive }) => (
          <div
            className={classNames(
              "group flex items-center gap-2 font-semibold pl-2 pr-4 py-2 ml-2 hover:text-sky-600",
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600"
            )}
          >
            <ReactSVG
              src="/media/icons/tire.svg"
              className={classNames(
                "w-5 h-5 group-hover:stroke-sky-600",
                isActive ? "stroke-sky-600" : "stroke-slate-500"
              )}
            />
            {t("admin.fleet.warehouses.tab.tires")}
          </div>
        )}
      </NavLink>
    </div>
  );
};

export default memo(TabMenu);
